<template>
  <el-row type="flex" justify="center" align="middle">
    <div v-for="(item, i) in row['belows']" :key="i" class="ma-2">
      <span style="margin-right: 5px">{{ $t("column.l" + item.group) }}</span>
      <span
        :class="['', { 'as-link': i == 0 }]"
        @click="i == 0 ? handleClick(item.group) : null"
        >{{ item.num || 0 }}</span
      >
    </div>
  </el-row>
</template>

<script>
export default {
  props: {
    group: [String, Number],
    row: Object,
  },
  computed: {
    groupMap() {
      return [70, 60, 40, 20, 10].filter((x) => x < this.group);
    },
  },
  methods: {
    handleClick(group) {
      this.$emit("on-click", { group, row: this.row });
    },
  },
};
</script>
